import { render } from "./AddDoctor.vue?vue&type=template&id=29077402&ts=true"
import script from "./AddDoctor.vue?vue&type=script&lang=ts"
export * from "./AddDoctor.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/poct.nikted.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__